import React from 'react'
import { useHistory } from 'react-router-dom'

import { PATHS } from 'Config/Routing/paths'
import ToggleLinks from '../ToggleLinks'
import { StyledWrapper, StyledLink } from './style'
import { getCurrentPage } from '../utils'

const PickupNav = () => {
  const history = useHistory()
  const pathname = history.location.pathname
  let basePath = pathname.substring(0, pathname.lastIndexOf('/'))
  let currentPage = getCurrentPage(pathname)
  const mainRoute = 'pickup'
  const re = /(\/)?pickup(\/)?/gi
  basePath = basePath.replace(re, '')
  if (currentPage === mainRoute) {
    currentPage = 'all'
  }
  return (
    <StyledWrapper>
      <ToggleLinks
        linkLeft={{
          text: 'Brief',
          url: `${basePath}${PATHS.cities.pickupBrief}`,
        }}
        linkRight={{
          text: 'All',
          url: `${basePath}${PATHS.cities.pickupAll}`,
        }}
        selectedLink={currentPage}
        mainRoute={mainRoute}
      />
      <StyledLink to={`${basePath}/manage-pickup-times`}>
        Manage Pickup times
      </StyledLink>
    </StyledWrapper>
  )
}

export default PickupNav
